import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const EsportsIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="22" height="21.55" viewBox="0 0 22 21.55">
		<g transform="translate(-2.496 -2.691)">
			<path
				d="M24.49,18.813c0-.081-.174-8.507-3.831-10.417a.04.04,0,0,0-.023-.012l-.127-.058a5.134,5.134,0,0,0-5.174.15c-1.655,1.03-2.107.938-3.681-.012a5.089,5.089,0,0,0-5.139-.15L6.33,8.4C2.7,10.295,2.5,18.721,2.5,18.779c-.012.857-.081,3.449,2.141,4.352a4.82,4.82,0,0,0,1.713.324A3.714,3.714,0,0,0,8.6,22.737a3.808,3.808,0,0,0,.857-.9,3.368,3.368,0,0,1,1.227-1.123,8.482,8.482,0,0,1,5.637,0,3.55,3.55,0,0,1,1.169,1.076,4.632,4.632,0,0,0,.914.949,4.131,4.131,0,0,0,3.97.394C24.571,22.228,24.513,19.635,24.49,18.813Z"
				transform="translate(0 0.787)"
				fill="#8d5aff"
				fillRule="evenodd"
			/>
			<path
				d="M9.48,5.7h1.042a1.192,1.192,0,0,1,1.215,1.1v.81a.868.868,0,1,0,1.736,0V6.8a2.934,2.934,0,0,0-2.951-2.836H9.48a.416.416,0,0,1-.405-.405.868.868,0,1,0-1.736,0A2.144,2.144,0,0,0,9.48,5.7Z"
				transform="translate(0.762)"
				fill="#41518e"
				fillRule="evenodd"
			/>
			<path
				d="M19.2,14.895a.857.857,0,1,1,0-1.713.857.857,0,0,1,0,1.713Zm-1.69,1.69a.857.857,0,1,1,0-1.713.857.857,0,1,1,0,1.713Zm-1.69-1.69a.857.857,0,1,1,0-1.713.857.857,0,1,1,0,1.713Zm1.69-3.414a.864.864,0,0,1,.857.868.855.855,0,0,1-.857.857.864.864,0,0,1-.868-.857A.874.874,0,0,1,17.514,11.481ZM9.863,14.964H9.111v.752a.868.868,0,0,1-1.736,0v-.752H6.507a.868.868,0,1,1,0-1.736h.868V12.36a.868.868,0,0,1,1.736,0v.868h.752a.868.868,0,1,1,0,1.736Z"
				transform="translate(0.495 1.384)"
				fill="#41518e"
				fillRule="evenodd"
			/>
		</g>
	</svg>
);
